import { AllCaps, Cap } from "../../types/caps";
import { AppThunk } from "../store";
import * as api from "../../utils/API";
export const RECEIVE_CAPS = "RECEIVE_CAPS";
export const RECEIVE_UPDATED_CAP = "UPDATE_CAP";
export const RECEIVE_NEW_CAP = "RECEIVE_NEW_CAP";
export const RECEIVE_DELETE_CAP = "RECEIVE_DELETE_CAP"
export const FETCHING_CAPS = 'FETCHING_CAPS';
export interface receiveCapsI {
    type: typeof RECEIVE_CAPS,
    data: AllCaps,
}
export interface receiveUpdatedCapI {

    type: typeof RECEIVE_UPDATED_CAP,
    data: Cap,
}
export interface receiveNewCapI {

    type: typeof RECEIVE_NEW_CAP,
    data: Cap,
}
export interface receiveDeleteCapI {

    type: typeof RECEIVE_DELETE_CAP,
    capID: number,
}

export const getCaps = (): AppThunk => async dispatch => {
    dispatch({ type: FETCHING_CAPS });
    const caps = await api.getCaps();

    dispatch({ type: RECEIVE_CAPS, data: caps });
}

export function receiveCaps(data: AllCaps): receiveCapsI {
    return {
        type: RECEIVE_CAPS,
        data
    }
}

export const receiveNewCap = (data: Cap): AppThunk => async dispatch => {
    try {
        const cap = await api.createCap(data);
        dispatch({ type: RECEIVE_NEW_CAP, data: cap })
    }
    catch (err) {
        throw err;
    }
}

export const receiveUpdatedCap = (data: Cap): AppThunk => async dispatch => {
    try {
        await api.updateCap(data);
        dispatch({ type: RECEIVE_UPDATED_CAP, data })
    }
    catch (err) {
        throw err;
    }
}

export const receiveDeleteCap = (capID: number): AppThunk => async dispatch => {
    try {
        await api.deleteCap(capID);
        dispatch({ type: RECEIVE_DELETE_CAP, capID })
    }
    catch (err) {
        throw err;
    }
}

